// extracted by mini-css-extract-plugin
export var graph = "style-module--graph--7e48a";
export var storer = "style-module--storer--9a4a1";
export var storer2 = "style-module--storer2--4286c style-module--storer--9a4a1";
export var storerContainer = "style-module--storerContainer--25657";
export var storerContainer2 = "style-module--storerContainer2--4f6d6 style-module--storerContainer--25657";